+function ($) {
    'use strict';

    $('#quick-order-file').change(function () {
        var currentFile = $('#quick-order-file').val(); // 上传文件地址
        var filePathArray = currentFile.split("\\"); // 文件地址数组化
        var fileName = filePathArray[filePathArray.length - 1]; // 获取文件名
        var fileNameArray = fileName.split('.'); // 文件名数组化
        var fileNameExtension = fileNameArray[fileNameArray.length - 1]; // 获取文件扩展名
        var acceptFileTypes = ".doc,.docx,.pdf,.jpg,.jpeg,.png,.xls,.xlsx"; // 可上传的文件扩展名

        if (acceptFileTypes.includes(fileNameExtension)) {
            // 文件类型可上传
            $('.files-content').css('display', 'flex');
            // 获取文件图标
            switch (fileNameExtension) {
                case 'pdf':
                    $('.file-img').attr('src', '/content/images/pdf.png');
                    break;
                case 'doc':
                case 'docx':
                    $('.file-img').attr('src', '/content/images/word.png');
                    break;
                case 'xlsx':
                case 'xls':
                    $('.file-img').attr('src', '/content/images/excel.png');
                    break;
                case 'jpg':
                case 'jpeg':
                case 'png':
                    $('.file-img').attr('src', '/content/images/jpg.png');
                    break;
                default: break
            }
            // 获取文件名
            $('.file-name').html(fileName)
        } else {
            $.submitQuickOrdermessage("warn","文件类型不对!");
        }
    });

    $(".create-quick-orders-button").click(function () {
        var userAddressId;
        var message = $(".buyer-message-textarea").val();
        $.each($(".address-item"), function (i, item) {
            if($(item).hasClass("address-item-selected")){
                userAddressId = $(item).children(".address-item-content-info").children(".modify-button-id").data("id").replace("modify-button-","")
            }
        })
        var filequickorder = $("#quick-order-file").val()

        $("#quickordermessage").val(message)
        $("#quickorderaddress").val(userAddressId)
        if (!isEmpty(message)) {
            if(message.length > 255) {
                $.submitQuickOrdermessage("warn", "买家留言最多255个字!");
                return false;
            }
        }
        if (isEmpty(userAddressId)) {
            $.submitQuickOrdermessage("warn","请输入收货地址并保存!");
            return false;
        }
        if(isEmpty($("#quick-order-file").val())){
            $.submitQuickOrdermessage("warn","请上传文件后提交!");
            return false;
        }
    })

    // 消息框
    var $message;
    var messageTimer;
    $.submitQuickOrdermessage = function() {
        var message = {};
        if ($.isPlainObject(arguments[0])) {
            message = arguments[0];
        } else if (typeof arguments[0] === "string" && typeof arguments[1] === "string") {
            message.type = arguments[0];
            message.content = arguments[1];
        } else {
            return false;
        }

        if (message.type == null || message.content == null) {
            return false;
        }

        if ($message == null) {
            $message = $('<div class="xxMessage" ><i class="iconfont icon-warning" style="float:left;"></i><div class="messageContent message' + escapeHtml(message.type) + 'Icon" STYLE="width : 120px;"><\/div><\/div>');
            if (!window.XMLHttpRequest) {
                $message.append('<iframe class="messageIframe"><\/iframe>');
            }
            $message.appendTo("body");
        }

        $message.children("div").removeClass("messagewarnIcon messageerrorIcon messagesuccessIcon").addClass("message" + message.type + "Icon").html(message.content);
        $message.css({"margin-left": - parseInt($message.outerWidth() / 2), "z-index": 9999}).show();

        clearTimeout(messageTimer);
        messageTimer = setTimeout(function() {
            $message.hide();
        }, 3000);
        return $message;
    }

    $("#quickOrder-new").on("click",function () {
        search()
    })

    $("#quickOrder-new-size-selector").on('change', function (e) {
        search()
    });

    function search(page) {
        var params = getParams();
        var size_sort = formatParam(params)+'&sort=createdTime,desc';
        // var urlStr = requestId ? '&category.id='+requestId + '&transverse' : searchFlg == 'sellWell' ? '&sellWell=true&search' : '&search&searchName=' + $('.j-searchInput').val();
        window.location.href =  '/mall/quick-orders/add?' + size_sort;
    }

    function getParams(defaultPage) {
        var page = defaultPage ? defaultPage : Number($("#notice-jump").val());
        var size = $("#quickOrder-new-size-selector").val();
        var total = $(".quickOrder-new-total").val();
        page = (page < 1 ? 1 : page > total ? total : page) - 1;
        return {
            page: page,
            size: size
        }

    }

    function formatParam(params) {
        return 'page=' + params.page + '&size=' + params.size;
    }

}(jQuery);
